<template>
    <b-container class="blog-list-section">
        <mobile-gutter>
            <b-row>
                <b-col
                    xl="10"
                    offset-xl="1"
                >
                    <transition name="fade" mode="out-in">
                        <div
                            class="list"
                            :key="blogs.map(({ title }) => title).join('-')"
                        >
                            <div
                                v-for="item in blogs"
                                :key="item.title"
                                class="list-item"
                            >
                                <item-card
                                    :image="item.thumbnail"
                                    :name="item.title"
                                    :description="formattedDate(item.dateTime)"
                                    :to="item.to"
                                />
                            </div>
                        </div>
                    </transition>
                </b-col>
            </b-row>
        </mobile-gutter>
    </b-container>
</template>

<script>
    import ItemCard from '../../molecules/ItemCard/ItemCard';
    import dayjs from 'dayjs';

    export default {
        name: 'blog-list-section',

        components: { ItemCard },

        props: {
            blogs: {
                type: Array,
                default: () => ([]),
            },
        },

        methods: {
            /**
             * Formatted date.
             *
             * @param {string} dateTime
             * @returns {string}
             */
            formattedDate(dateTime) {
                return dayjs(dateTime).format('DD/MM/YY');
            },
        },
    };
</script>

<style lang="scss" scoped>
    .fade-enter-active,
    .fade-leave-active {
        transition: 0.5s;
    }

    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }

    .list {
        @include media-breakpoint-up(sm) {
            display: grid;
            grid-template-columns: repeat(2, minmax(0, 1fr));
            grid-column-gap: 20px;
        }
        @include media-breakpoint-up(lg) {
            display: grid;
            grid-template-columns: repeat(3, minmax(0, 1fr));
            grid-column-gap: 40px;
        }
        @include media-breakpoint-up(xl) {
            grid-column-gap: 80px;
        }
    }

    .list-item {
        margin-bottom: 24px;
        @include media-breakpoint-up(lg) {
            margin-bottom: 40px;
        }
    }

    .item-card {
        max-width: 327px;
        margin-left: auto;
        margin-right: auto;
        @include media-breakpoint-up(lg) {
            max-width: unset;
        }

        ::v-deep {
            .description {
                margin-top: auto;
            }
        }
    }
</style>
